import { booleanAttribute, Component, effect, inject, input, model, numberAttribute, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';

import { ChatAvatarComponent } from '@shared/_chats/chat-avatar.component';
import { NamesListModule } from '@shared/_views/names-list.module';

import { BaseMin } from '@base/base-min';
import { Chat, ChatCallStatus, ChatStatus, ChatStatusIcon, ChatStatusName, ChatType, Guid } from '@models';
import { CacheService } from '@services/cache.service';

@Component({
    selector: 'vz-chat-row, [vz-chat-row]',
    templateUrl: './chat-row.component.html',
    imports: [
        CommonModule, FormsModule, ReactiveFormsModule,
        NzButtonModule, NzCheckboxModule,
        ChatAvatarComponent, NamesListModule
    ],
    styles: ':host { overflow: hidden; }'
})
export class ChatRowComponent extends BaseMin {

    readonly chatId         = input<Guid>();
    readonly checked        = model<boolean>(false);
    readonly selectable     = input<boolean, unknown>(true, { transform: booleanAttribute });
    readonly noDescription  = input<boolean, unknown>(false, { transform: booleanAttribute });
    readonly avatarSize     = input<number, unknown>(46, { transform: numberAttribute });

    readonly itemClick      = output<MouseEvent>();

    readonly chat           = signal<Chat | undefined>(undefined);

    CT = ChatType;
    CS = ChatStatus;
    CSN: any = ChatStatusName;
    CSI: any = ChatStatusIcon;
    CCS = ChatCallStatus;

    private readonly _cache     = inject(CacheService);

    private _1 = effect(() => {
        this.__U(['chat']);
        const chatId = this.chatId();
        if (chatId) {
            this._S.chat = this._cache.watch('chat', chatId).subscribe(st => this.chat.set(st.item));
        }
        else {
            this.chat.set(undefined);
        }
    });

}
